import { Component } from 'react';
import {
    Box, Button, MenuItem, Paper, Tooltip, Menu, IconButton, Stack, Typography
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next'
import './Billings.css';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import { ImagePaths } from '../../../Utility/ImagePaths';
import Drawer from '@mui/material/Drawer';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BillingsFilter from './BillingsFilter';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import PrintPreviewPop from '../../../Components/Common Components/PrintPreviewPop';
import { AmountFormat, CheckAccessFunc, CheckCashCounterAccess, ContentInTooltip, formatDate, timeOnlyConvert } from '../../../Components/CommonFunctions/CommonFunctions';
import { BillSuccessPoPUp, CommonCorporateAndInsuranceDetails, CommonGridToolBarWithFilterTextCustom, CommonPatientDetails } from '../../../Components/Common Components/CommonComponents';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import CreditTypeChangePop from './CreditTypeChangePop';
import CreditBillCompletePoP from './CreditBillCompletePoP';
import CreditPaymentPopup from '../CreditSettlement/CreditPaymentPopup';
import { creditCorpTypes, CurrencySymbol } from '../../../Utility/Constants';

class CreditBills extends Component {
    constructor(props) {
        super(props)
        let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
        let PharmacyList = LoggedData?.pharmacy_data ? JSON.parse(JSON.stringify(LoggedData?.pharmacy_data)).map((list) => list?.pharmacy_id) : []
        let LabList = LoggedData?.laboratory_data ? JSON.parse(JSON.stringify(LoggedData?.laboratory_data)).map((list) => list?.laboratory_id) : []
        let isNewBilling = (localGetItem("isNewBilling") === "true") ? true : false;
        this.state = {
            page: 0,
            pageSize: 10,
            BillList: [],
            ref: props.location?.pathname,
            FilterOpen: false,
            FilterDatas: {
                "FromDate": DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "ToDate": DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "DateIndex": 1,
                "PatientName": "",
                "AccNo": "",
                "MobNo": "",
                "DoctorName": [],
                "BillNumber": "",
                "PaidAmount": "",
                "InPatientSelected": true,
                "OutPatientSelected": true,
                "PharmacySelected": localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true,
                "LaboratorySelected": isNewBilling ? false : true,
                "ImageLabSelected": isNewBilling ? false : true,
                "OTSelected": true,
                "PaidSelected": true,
                "PartialPaidSelected": true,
                "CreditSelected": true,
                "CardSelected": true,
                "CashSelected": true,
                "UPISelected": true,
                "BankTransferSelected": true,
                "InsuranceSelected": true,
                "ChequeSelected": true,
                "BillType": ['op', 'ip', (localGetItem("Show_Pharmacy_Bills_In_FO") === "true") && 'pharmacy', ((localGetItem("Show_Radiology_Bills_In_FO") === "true") && (localGetItem("isNewBilling") === "false")) && 'radiology', (localGetItem('isNewBilling') === "false") && ['lab'], 'ot'].flat().filter(Boolean),
                "PayStatus": [],
                "PayMethods": [],
                "CreditStatus": [(localGetItem('isNewBilling') === "true") ? 'Corporate credit' : 'Corprate credit', 'Insurance credit', 'Patient credit'],
                "Insurance": true,
                "CorporateCredit": true,
                "PatientCredit": true,
                "startTime": null,
                "endTime": null,
                "is_bill_wise": (localGetItem("credit_bill_flt_config") === "bill_wise") ? true : false,
                "frontOfficeCrBills": isNewBilling ? true : false,
                "opCreditBills": isNewBilling ? false : true,
                "ipCreditBills": isNewBilling ? false : true,
                "pharmaCreditBills": localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true,
                "labCreditBills": true,
                "BillModuleType": ['lab', (localGetItem("Show_Pharmacy_Bills_In_FO") === "true") && 'pharmacy', (localGetItem("Show_Radiology_Bills_In_FO") === "true") && 'radiology', (localGetItem("isNewBilling") === "false") ? ['ip', 'op', "ot"] : ['fo']].flat().filter(Boolean),
                "RadiologyBills": localGetItem("Show_Radiology_Bills_In_FO") === "true" ? true : false,
                "RadiologySelected": (localGetItem("isNewBilling") === "false" && localGetItem("Show_Radiology_Bills_In_FO") === "true") ? true : false,
                "radiologyCreditBills": localGetItem("Show_Radiology_Bills_In_FO") === "true" ? true : false,
                "phoneNumber": '',
                "patient_Name": '',
                "UHID_No": '',
                "IncludePaidBills": false,
                "Bill_No": '',
                'MultiPharmaIds': localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? [] : PharmacyList,
                'MultiLabIds': LabList,
                'MultiInvestigations': localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : [],
                "otCreditBills": isNewBilling ? false: true,
                "insuranceName": [],
                "corporateName": [],
                "insuranceData": [],
                "corporateData": [],
                'UserList': [],
                'UserDetails': [],
            },
            AmountDetails: {
                "Total": 0,
                "Paid": 0,
                "Pending": 0,
            },
            CreditBillPopUp: false,
            SelectedBill: {},
            BillPreviewPop: false,
            CreditTypeChangePopup: false,
            pharmareceipt: null,
            receiptID: null,
            LoggedData: LoggedData,
            paymentPopupOpen: false
        }
    }


    componentDidMount() {
        this.GetBillList()
        this.getCorporateDetails()
        this.getInsuranceDetails()
        this.GetUserDetails()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    handleclose = (callAPI) => {
        this.setState({
            paymentPopupOpen: false
        }, () => {
            if (callAPI) {
                this.GetBillList()
            }
        })
    }

    getCreditPopupUrl() {
        const { SelectedBill } = this.state;

        if (SelectedBill?.insuranceName) {
            const InsuranceName = encodeURIComponent(SelectedBill.insuranceName || '')
            const baseUrl = Serviceurls.INSURANCE_BILL_GET;
            if (SelectedBill.bill_types === "In Patient") {
                return `${baseUrl}?ip_admission_id=${SelectedBill.module_id}&insurance_company_name=${InsuranceName}`;
            } else {
                return `${baseUrl}?appointment_id=${SelectedBill.module_id}&insurance_company_name=${InsuranceName}`;
            }
        } else {
            const baseUrl = Serviceurls.CORPORATE_BILL_GET;
            const CorpName = encodeURIComponent(SelectedBill.employer_name || '')
            if (SelectedBill?.bill_types === "In Patient") {
                return `${baseUrl}?ip_admission_id=${SelectedBill.module_id}&company_name=${CorpName}`;
            } else if (SelectedBill?.bill_types === "Out Patient") {
                return `${baseUrl}?appointment_id=${SelectedBill.module_id}&company_name=${CorpName}`;
            } else if (SelectedBill?.bill_types === "Pharmacy") {
                return `${baseUrl}?ph_bill_id=${SelectedBill.module_id}&company_name=${CorpName}`;
            } else {
                return `${baseUrl}?bill_id=${SelectedBill.module_id}&company_name=${CorpName}`;
            }
        }
    }

    getInsuranceDetails = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.state.FilterDatas.insuranceData = response.data.data
                        this.setState({
                            FilterDatas : this.state.FilterDatas
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status) {
                        this.successErrorMessgae(error.response.data.message, 'error')
                    } else {
                        this.successErrorMessgae(error.message, 'error')
                    }
                })
        } catch (error) {
            this.successErrorMessgae(error.message, 'error')
        }
    }
    getCorporateDetails = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.state.FilterDatas.corporateData = response.data.data
                        this.setState({
                            FilterDatas: this.state.FilterDatas
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status) {
                        this.successErrorMessgae(error.response.data.message, 'error')
                    } else {
                        this.successErrorMessgae(error.message, 'error')
                    }
                })
        } catch (error) {
            this.successErrorMessgae(error.message, 'error')
        }
    }

    GetBillList() {
        try {
            var states = this.state
            let User_ID = []
            states.FilterDatas.UserDetails.forEach(element => User_ID.push(element.id))
            let start_time = states.FilterDatas.startTime ? new Date(states.FilterDatas.startTime) : ''
            let end_time = states.FilterDatas.endTime ? new Date(states.FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

            let doctorId = [];
            states.FilterDatas?.DoctorName.forEach(element => doctorId.push(element?.doctor_id))
            this.LoaderFunction(true)
            const { FilterDatas } = states;
            const billedFrom = states.FilterDatas.is_bill_wise ? (localGetItem("isNewBilling") === "true" ? ("&billed_from=" + [...states?.FilterDatas?.BillModuleType, ...states?.FilterDatas?.MultiInvestigations] || [])  : ("&bills=" + states?.FilterDatas?.BillModuleType) ) : "&bills=";
            const insuranceIds = FilterDatas.insuranceName?.map(item => item.insurance_id).join(",");
            const corporateIds = FilterDatas.corporateName?.map(item => item.id).join(",");
            let creditFilter = "";
            if (FilterDatas.CreditStatus.length === 1) {
                const status = FilterDatas.CreditStatus[0];
                if (status === "Insurance credit") {
                    creditFilter = insuranceIds ? `&filter_insurance=${insuranceIds}` : "";
                } else if (status === "Corporate credit" || status === "Corprate credit") {
                    creditFilter = corporateIds ? `&filter_corporate=${corporateIds}` : "";
                }
            }
            const baseUrl = (localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_CREDIT_BILLS_GET : Serviceurls.CREDIT_BILLS_GET;
            RestAPIService.getAll(baseUrl +
                "?from_date=" + states.FilterDatas.FromDate +
                "&to_date=" + states.FilterDatas.ToDate +
                "&moduel_type=" + states.FilterDatas.BillType +
                "&credit_type=" + states.FilterDatas.CreditStatus +
                "&is_bill_wise=" + states.FilterDatas.is_bill_wise +
                billedFrom +
                creditFilter +
                "&start_time=" + setStartTime +
                "&end_time=" + setEndTime +
                "&patient_name=" + states.FilterDatas.patient_Name +
                "&uhid=" + states.FilterDatas.UHID_No +
                "&user_id=" + User_ID +
                "&mob_no=" + states.FilterDatas.phoneNumber +
                "&bill_number=" + states.FilterDatas.Bill_No +
                "&include_paid_bill=" + states.FilterDatas.IncludePaidBills +
                "&pharmacy_id=" + states?.FilterDatas?.MultiPharmaIds +
                "&laboratory_id=" + states?.FilterDatas?.MultiLabIds
            ).
                then((response) => {
                    if (response.data.status === "success") {
                        states.AmountDetails.Total = response?.data?.total_amount;
                        states.AmountDetails.Paid = (response?.data?.total_amount ? +response?.data?.total_amount : 0) - (response?.data?.pending_amount ? +response?.data?.pending_amount : 0);
                        states.AmountDetails.Pending = response?.data?.pending_amount;
                        this.setState({
                            BillList: response.data.data,
                            AmountDetails: states.AmountDetails,
                        }, () => { this.LoaderFunction(false) })
                    }
                    else {
                        this.LoaderFunction(false)
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        this.LoaderFunction(false)
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.LoaderFunction(false)
                        this.errorMessage(error.message)
                    }
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    GetUserDetails = () => {
        let states = this.state
        try {
            RestAPIService.getAll(Serviceurls.DAY_END_USER_DETAIL_GET + `?show_all=true`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const UserList = response.data.data
                        this.setState((prevState) => ({
                            FilterDatas: {
                                ...prevState.FilterDatas,
                                UserList: UserList
                            }
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }

                })
        } catch (error) {
            this.errorMessage(error)
        }
    }

    printCreditBills = () => {
        let states = this.state
        let User_ID = []
        states.FilterDatas.UserDetails.forEach(element => User_ID.push(element.id)) 
        let start_time = states.FilterDatas.startTime ? new Date(states.FilterDatas.startTime) : ''
        let end_time = states.FilterDatas.endTime ? new Date(states.FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

        try {
            const { FilterDatas } = states;
            const billedFrom = states.FilterDatas.is_bill_wise ? (localGetItem("isNewBilling") === "true" ? ("&billed_from=" + [...states?.FilterDatas?.BillModuleType, ...states?.FilterDatas?.MultiInvestigations] || [])  : ("&bills=" + states?.FilterDatas?.BillModuleType) ) : "&bills=";
            const insuranceIds = FilterDatas.insuranceName?.map(item => item.insurance_id).join(",");
            const corporateIds = FilterDatas.corporateName?.map(item => item.id).join(",");
            let creditFilter = "";
            if (FilterDatas.CreditStatus.length === 1) {
                const status = FilterDatas.CreditStatus[0];
                if (status === "Insurance credit") {
                    creditFilter = insuranceIds ? `&filter_insurance=${insuranceIds}` : "";
                } else if (status === "Corporate credit" || status === "Corprate credit") {
                    creditFilter = corporateIds ? `&filter_corporate=${corporateIds}` : "";
                }
            }
            const baseUrl = (localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_CREDIT_BILLS_GET : Serviceurls.CREDIT_BILLS_GET;
            RestAPIService.getAllPrint(baseUrl +
                "?from_date=" + states.FilterDatas.FromDate +
                "&to_date=" + states.FilterDatas.ToDate +
                "&moduel_type=" + states.FilterDatas.BillType +
                "&credit_type=" + states.FilterDatas.CreditStatus +
                "&start_time=" + setStartTime +
                "&end_time=" + setEndTime +
                "&is_bill_wise=" + states.FilterDatas.is_bill_wise +
                billedFrom +
                creditFilter +
                "&patient_name=" + states.FilterDatas.patient_Name +
                "&user_id=" + User_ID +
                "&uhid=" + states.FilterDatas.UHID_No +
                "&mob_no=" + states.FilterDatas.phoneNumber +
                "&bill_number=" + states.FilterDatas.Bill_No +
                "&include_paid_bill=" + states.FilterDatas.IncludePaidBills +
                "&pharmacy_id=" + states?.FilterDatas?.MultiPharmaIds +
                "&laboratory_id=" + states?.FilterDatas?.MultiLabIds +
                "&export=" + "pdf"
            )
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    printIndividualPrint = (billData) => {
        try {
            let url = ''
            let lab_id = billData?.laboratory_id ? billData?.laboratory_id : null
            if (billData?.patient_bill_type === "OT") {
                url = Serviceurls.GET_PRINT_PREVIEW + `?export=pdf&id=` + billData?.id
            }
            else if (billData?.patient_bill_type === "In Patient") {
                url = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_IP_INVOICE_PRINT : Serviceurls.IP_INVOICE_PRINT) + `?export=pdf&ip_bill_summary_id=` + billData?.id
            }
            else if (billData?.patient_bill_type === "Out Patient") {
                url = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_OP_INVOICE_PRINT : Serviceurls.OP_INVOICE_PRINT) + "?export=pdf&invoce_id=" + billData?.id
            }
            else if (billData?.patient_bill_type === "Pharmacy") {
                url = Serviceurls.PHARMACY_INVOICE_PRINT + "?id=" + billData?.id + "&export=pdf"
            }
            else if (billData?.patient_bill_type === "Laboratory") {
                url = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_LAB_CREATE_BILL_COMPLETED_PRINT : Serviceurls.LAB_CREATE_BILL_COMPLETED_PRINT) + "?bill_summary_id=" + billData?.id + "&export_type=pdf" + "&laboratory_id=" + lab_id
            }
            else if (billData?.patient_bill_type === "Radiology") {
                url = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_RAD_BILL_POST : Serviceurls.RAD_BILL_POST) + '?bill_summary_id=' + billData?.id + "&export_type=pdf"
            }
            else if (billData?.billing_status) {
                url = Serviceurls.PHARMA_BILLS_GET + "?id=" + billData?.id + "&export=pdf"
            }
            RestAPIService.getAllPrint(url).
                then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                    }
                }).catch((error) => {
                    console.log(error.message)
                })
        } catch (e) {
            console.log(e.message)
        }
    }

    closeFilter() {
        this.setState({
            FilterOpen: false
        })
    }

    MenuItem = (data) => {
        const { t } = this.props
        const multi_option = [
            { value: "ChangeCreditType", label: t("Change Credit Type") },
        ]
        return (
            <div>
                <Tooltip title={t("More")} placement='top' arrow>
                    <IconButton
                        disabled={data.row.pending_amount === 0}
                        onClick={(e) => {
                            this.setState({
                                anchorEl: e.currentTarget,
                                selectedRow: data.id,
                                isSelected: true
                            })
                        }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
                {(this.state.isSelected && this.state.selectedRow == data.id) ?
                    <Menu
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={() => {
                            this.setState({ anchorEl: null, })
                        }}>
                        {multi_option.map((option) => (
                            <MenuItem key={option}
                                disabled={this.state.CreditTypeChangePopup}
                                onClick={() => {
                                    this.setState({ anchorEl: null }, () => {
                                        if (option.value === "ChangeCreditType") {
                                            data.row.employee_id = data?.row?.employee_id_no ? data?.row?.employee_id_no : "";
                                            this.setState({ CreditTypeChangePopup: true, SelectedBill: data?.row })
                                        }
                                    })
                                }}>
                                {t(option.label)}
                            </MenuItem>
                        ))}
                    </Menu> : null}
            </div>
        )
    }
    ClosePopUp(Getapicall = false, message = "") {
        this.setState({
            CreditBillPopUp: false,
            BillPreviewPop: false,
            CreditTypeChangePopup: false,
        }, () => {
            if (Getapicall && message !== "") {
                this.successMessage(message)
                this.GetBillList()
            }
        })
    }
    CrebillPosted(message = "", rec = null, phrrec = null, error = false) {
        this.setState({
            CreditBillPopUp: false,
            CreditTypeChangePopup: false,
            receiptID: rec,
            pharmareceipt: phrrec,
        }, () => {
            if (error) {
                this.errorMessage(message)
            } else {
                this.successMessage(message)
            }
            this.GetBillList()
        })
    }

    CrebillTypeChaged(message) {
        this.setState({
            CreditBillPopUp: false,
            CreditTypeChangePopup: false,
        }, () => {
            this.successMessage(message)
            this.GetBillList()
        })
    }

    renderFilter = (data) => {
        this.setState({
            FilterDatas: data,
            FilterOpen: false,
            SearchedFilters: data
        }, () => { this.GetBillList() })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    gridToolBar = () => {
        var { t } = this.props

        let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
        let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilterDatas.FromDate) },
            { label: "To Date", value: formatDate(this.state.FilterDatas.ToDate) },
        ]
        if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
            TextArray.push(
                { label: "Start Time", value: timeOnlyConvert(setStartTime) },
                { label: "End Time", value: timeOnlyConvert(setEndTime) }
            )
        }
        var ExportData = []
        this.state.BillList?.length > 0 && this.state.BillList.map((item) => 
        ExportData.push({
            "Patient Name": item.patient_names, 
            "Patient UHID":item.uhid,
            "Mobile":item.mobile_number,
            "Date":item.appointment_dates, 
            "Module Number":item.module_number, 
            "Module Type": item.bill_types, 
            "Credit Type": item.credit_type, 
            "Credit Company Name": item.credit_type === "Insurance credit" ? item?.insurance_name : item?.credit_type === "Corprate credit" ? item?.employer_name : '', 
            "Total Bill": item.total_amount,
            "Pending Amount": item.pending_amount })
        )
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"FO Credit Bills"} FilterTextArray={TextArray} filename={"CreditBills"} />
            </Box>

        )
    }

    clearFilter = (data) => {
        this.setState({
            FilterDatas: data
        })
    }

    ClosesuccessPopUp = () => {
        this.setState({
            receiptID: null,
            pharmareceipt: null
        })
    }

    render() {
        const { t } = this.props
        this.state.BillList.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: "patient_names", flex: 0.17, headerName: t("PatientDetails"),
                renderCell: (params) => (
                    <Box>
                        <CommonPatientDetails disablePhoto={true} data={params?.row} fromCreditBill={true} hideInsurance = {true}/>
                    </Box>
                ), valueGetter: (params) => {
                    const name = params.row?.patient_names || "";
                    const mobile = params.row?.mobile_number || "";
                    const UHID = params.row?.uhid || "";
                    return `${name} ${mobile} ${UHID}`;
                }
            },
            {
                field: "appointment_date", flex: 0.1, headerName: t("Date"), headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.appointment_dates ? formatDate(params?.row?.appointment_dates) : "-"}</Box>)
            },
            {
                field: 'module_number', headerName: t('OP/IP/LAB/Pharmacy No'), sortable: false, flex: 0.14, headerAlign: "center", align: "center",
                renderCell: (params) => {
                    let BillNumber = params?.row?.module_number ? (params?.row?.module_number) : "-";
                    const billArr = BillNumber ? BillNumber.split("/") : [];
                    return (
                        <Tooltip placement='top' title={BillNumber} arrow>
                            <Box component={'div'}>{billArr?.length > 0 ? '...' + billArr.slice(-2).join("/") : "-"}</Box>
                        </Tooltip>
                    )
                }
            },
            {
                field: "bill_types", flex: 0.14, headerName: this.state?.FilterDatas?.is_bill_wise ? t("BillType") : t("Module Type"),
                renderCell: (params) => {
                    let AddmissionWiseText = `${(localGetItem("multiLaboratory") === "true" && params?.row?.bill_types === "Laboratory") ? (params?.row?.laboratory_name ? ` - ${params?.row?.laboratory_name}` : "-") : (localGetItem("multiPharmacy") === "true" && params?.row?.bill_types === "Pharmacy") ? (params?.row?.pharmacy_name ? ` - ${params?.row?.pharmacy_name}` : "-") : ""}`
                    let BillWiseText = `${(this.state?.FilterDatas?.is_bill_wise && localGetItem("multiLaboratory") === "true" && params?.row?.patient_bill_type === "Laboratory") ? (params?.row?.laboratory_name ? ` - ${params?.row?.laboratory_name}` : "-") : (this.state?.FilterDatas?.is_bill_wise && localGetItem("multiPharmacy") === "true" && params?.row?.patient_bill_type === "Pharmacy") ? (params?.row?.pharmacy_name ? ` - ${params?.row?.pharmacy_name}` : "-") : ""}`
                    let BilTypeText = `${this.state?.FilterDatas?.is_bill_wise ? (params?.row?.patient_bill_type ? params?.row?.patient_bill_type : '-') : params?.row?.bill_types ? params?.row?.bill_types : "-"} ${this.state?.FilterDatas?.is_bill_wise ? BillWiseText : AddmissionWiseText}`
                    return <Box component={'div'}>
                        {/* <Typography>`${this.state?.FilterDatas?.is_bill_wise ? (params?.row?.patient_bill_type ? params?.row?.patient_bill_type : '-') : params?.row?.bill_types ? params?.row?.bill_types : "-"}`</Typography>
                        <Typography>``</Typography> */}
                        {ContentInTooltip(BilTypeText, 20)}
                        {(this.state?.FilterDatas?.is_bill_wise && params?.row?.bill_types !== params?.row?.patient_bill_type) ? <Typography fontSize={'0.8vw'}>{params?.row?.bill_types ? params?.row?.bill_types : "-"}</Typography> : null}
                    </Box>
                },
                valueGetter: (params) => {
                    const name = params?.row?.credit_type || "";
                    const creditType = creditCorpTypes.has(params?.row?.credit_type) ? params?.row?.employer_name : (params?.row?.credit_type === "Insurance credit" ? params?.row?.insurance_name : "-")
                    return `${name} ${creditType}`;
                }
            },
            {
                field: "credit_type", flex: 0.11, headerName: t("CreditType"),
                renderCell: (params) => (
                    <Box component={'div'}>
                        {params?.row?.credit_type ? <CommonCorporateAndInsuranceDetails data={params?.row} /> : "-"}
                    </Box>),
                valueGetter: (params) => {
                    const name = params?.row?.credit_type || "";
                    const creditType = creditCorpTypes.has(params?.row?.credit_type) ? params?.row?.employer_name : (params?.row?.credit_type === "Insurance credit" ? params?.row?.insurance_name : "-")
                    return `${name} ${creditType}`;
                }
            },
            {
                field: "total_amount", flex: 0.11, headerName: t('TotalBill') + ` (${CurrencySymbol})`, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.total_amount ? AmountFormat(params?.row?.total_amount) : params?.row?.total_amount === 0 ? "0.00" : "-"}</Box>)
            },
            {
                field: "pending_amount", flex: 0.11, headerName: t('PendingAmount') + ` (${CurrencySymbol})`, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.pending_amount ? AmountFormat(params?.row?.pending_amount) : params?.row?.pending_amount === 0 ? "0.00" : "-"}</Box>)
            },
            {
                field: "action", flex: 0.12, headerName: t("Action"), headerAlign: "center", align: "center", sortable: false,
                renderCell: (params) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                    <Tooltip title={t("Receive Payment")} placement="top" arrow>
                        <Button disabled={this.state.LoggedData?.module_name === "Doctor" ? true : !CheckAccessFunc("front_office", "Billing Transaction", 'Credit Bills', null, "Tab")?.editAccess ? true : params?.row?.pending_amount === 0 ? true : !(params?.row?.bill_types === "In Patient" || params?.row?.bill_types === "Out Patient" || params?.row?.bill_types === "Laboratory" || params?.row?.bill_types === "Radiology" || (params?.row?.bill_types === "Pharmacy" && localGetItem("Allow_Pharma_CreditBill_In_FO") === "true") || (CheckCashCounterAccess() || (localGetItem('isNewBilling') === "false")))} className='eMed_usrconf_btn' onClick={() => {
                            if ((localGetItem('isNewBilling') === "true")) {
                                this.props?.history?.push({ pathname: "/HospitalBilling/CashCounter", states: { patient_details: { ...params.row, patient_account_number: params?.row?.uhid }, return_path: "/BillingTransaction/CreditBills", back_button_lable: "Back to Credit Bills", module: ((params?.row?.bill_types === "In Patient" || params?.row?.bill_types === "OT") ? "ip" : params?.row?.bill_types === "Out Patient" ? "op" : "self"), search_label: (params?.row?.bill_types === "In Patient" ? "ip_admission_id" : params?.row?.bill_types === "Out Patient" ? "appointment_id" : "patient_id"), search_value: ((params?.row?.bill_types === "In Patient" || params?.row?.bill_types === "Out Patient") ? params.row?.module_id : params.row?.module_number) } })
                            } else {
                                this.setState({
                                    CreditBillPopUp: true,
                                    SelectedBill: params.row
                                })
                            }
                        }}>
                            <img src={this.state.LoggedData?.module_name !== "Doctor" && (CheckAccessFunc("front_office", "Billing Transaction", 'Credit Bills', null, "Tab")?.editAccess && (params?.row?.bill_types === "In Patient" || params?.row?.bill_types === "Out Patient" || params?.row?.bill_types === "Laboratory" || params?.row?.bill_types === "Radiology" || params?.row?.bill_types === "OT" || (params?.row?.bill_types === "Pharmacy" && localGetItem("Allow_Pharma_CreditBill_In_FO") === "true")) && params?.row?.pending_amount !== 0 && (CheckCashCounterAccess() || (localGetItem('isNewBilling') === "false"))) ? ImagePaths.CreateBill.default : ImagePaths.DisabledCreateBill.default} alt="Credit Bill" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                    {this.state.FilterDatas.is_bill_wise ?
                        <Tooltip title={t("PrintBill")} placement="top" arrow>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.printIndividualPrint(params.row) }}>
                                <img src={ImagePaths.PrintIcons.default} alt="print" className='eMed_action_img' />
                            </Button>
                        </Tooltip> : null}
                    {(CheckAccessFunc("front_office", "Billing Transaction", 'Credit Bills', null, "Tab")?.editAccess && (params?.row?.bill_types === "In Patient" || params?.row?.bill_types === "Out Patient" || params?.row?.bill_types === "Laboratory" || params?.row?.bill_types === "Radiology" || (params?.row?.bill_types === "Pharmacy" && localGetItem("Allow_Pharma_CreditBill_In_FO") === "true")) && params?.row?.pending_amount !== 0 && (CheckCashCounterAccess() || (localGetItem('isNewBilling') === "false"))) ? this.MenuItem(params) : ''}
                </Box>
            }
        ]
        return (
            <Box component={"div"} className='eMed_Main_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("Total Bill Amount"), this.state.AmountDetails.Total ? this.state.AmountDetails.Total : 0)}
                        {AmountsCard(t("Total Paid Amount"), this.state.AmountDetails.Paid ? this.state.AmountDetails.Paid : 0)}
                        {AmountsCard(t("Total Pending Amount"), this.state.AmountDetails.Pending ? this.state.AmountDetails.Pending : 0)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Tooltip title="Filter" placement='top' arrow>
                                <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                    <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                                </Button>
                            </Tooltip>
                        </Box>
                        <Tooltip title="Print" placement='top' arrow>
                            <Button className='eMed_usrconf_btn' onClick={() => this.printCreditBills()}>
                                <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                            </Button>
                        </Tooltip>
                        {/* <Tooltip title="Export" placement='top' arrow>
                            <Button className='eMed_usrconf_btn'>
                                <img src={ImagePaths.LabUploadButton.default} alt="upload" className='eMed_action_img' />
                            </Button></Tooltip> */}
                    </Box>
                </Box>
                <Box component={"div"} className='eMed_Table_Container'>
                    <Stack component={"div"}>
                        <Paper className='eMed_Table_Wrapper' >
                            <DataGrid
                                rows={this.state.BillList}
                                columns={columns}
                                getRowId={(row) => row['sno']}
                                page={this.state.page}
                                pageSize={this.state.pageSize}
                                hideFooterSelectedRowCount
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                headerHeight={40}
                                components={{
                                    Toolbar: this.gridToolBar,
                                    NoRowsOverlay: () => (
                                        <Stack className='eMed_conf_nodata'>
                                            {t("NoRecordsFound")}
                                        </Stack>
                                    )
                                }}
                                rowsPerPageOptions={[10, 20, 30]}
                                disableSelectionOnClick
                                pagination
                                onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                                onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                loading={this.state.isLoader}
                            />
                        </Paper>
                    </Stack>
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter.bind(this) }}
                >
                    <BillingsFilter PageName={"CreditBills"} FilterDatas={this.state.FilterDatas} CloseFilter={this.closeFilter.bind(this)} FilteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} />
                </Drawer>
                {
                    this.state.CreditBillPopUp ?
                        <CreditBillCompletePoP
                            modules={this.state.SelectedBill?.bill_types === "Out Patient" ? ['op', 'lab', 'pharmacy', 'radiology'] : this.state.SelectedBill?.bill_types === "In Patient" ? ['ip', 'lab', 'pharmacy', 'radiology', 'ot'] : this.state.SelectedBill?.bill_types === "Pharmacy" ? ['pharmacy'] : this.state.SelectedBill?.bill_types === "Laboratory" ? ['lab'] : this.state.SelectedBill?.bill_types === "Radiology" ? ['radiology'] : []}
                            Module_ID_Key_Name={this.state.SelectedBill?.bill_types === "Out Patient" ? "appointment_id" : this.state.SelectedBill?.bill_types === "In Patient" ? "ip_admission_id" : "bill_id"}
                            Module_ID_Key_Value={this.state.SelectedBill?.module_id}
                            BillData={this.state.SelectedBill}
                            CrebillPosted={this.CrebillPosted.bind(this)}
                            ClosePopUp={this.ClosePopUp.bind(this)}
                            CollectedIn={this.state.SelectedBill?.bill_types === "Out Patient" ? "OP" : this.state.SelectedBill?.bill_types === "In Patient" ? "IP" : this.state.SelectedBill?.bill_types === "Pharmacy" ? "FO PH" : this.state.SelectedBill?.bill_types === "Laboratory" ? "FO LAB" : this.state.SelectedBill?.bill_types === "Radiology" ? "FO RAD" : ""}
                            Bill_Id={this.state.FilterDatas?.is_bill_wise ? ((this.state.SelectedBill?.bill_types === "Out Patient" || this.state.SelectedBill?.bill_types === "In Patient") ? this.state.SelectedBill?.id : null) : null}
                            from={this.state.FilterDatas?.is_bill_wise ? "" : 'admission_wise'}
                            FromFrontOffice={true}
                        />
                        : null
                }
                {
                    this.state.CreditTypeChangePopup ? <CreditTypeChangePop BillData={this.state.SelectedBill} CrebillTypeChaged={this.CrebillTypeChaged.bind(this)} ClosePopUp={this.ClosePopUp.bind(this)} /> : null
                }
                {
                    this.state.BillPreviewPop ?
                        <PrintPreviewPop
                            URL={Serviceurls.INVOICE_PRINT}
                            Title={t("BillPreview")}
                            BillData={this.state.SelectedBill}
                            ClosePopUp={this.ClosePopUp.bind(this)}
                            ModifyBillButton={false}
                            cancelBillButton={CheckAccessFunc("front_office", "Billing Transaction", 'Credit Bills', null, "Tab")?.editAccess && (this.state.SelectedBill?.bill_types === "In Patient" || this.state.SelectedBill?.bill_types === "Out Patient")}
                            PrintButton={false}
                            history={this.props.history} /> : null
                }
                <CreditPaymentPopup
                    open={this.state.paymentPopupOpen}
                    onClose={this.handleclose.bind(this)}
                    patientData={this.state.SelectedBill}
                    getApiUrl={this.getCreditPopupUrl()}
                    postApiUrl={Serviceurls.COMMON_CREDIT_PAYMENT_POST}
                    type={this.state.SelectedBill?.insuranceName ? "Insurance credit" : "Corporate credit"}
                    errorMessage={this.errorMessage.bind(this)}
                    successMessage={this.successMessage?.bind(this)}
                />
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {/* <Loader loaderOpen={this.state.isLoader} /> */}
                {this.state.receiptID !== null || this.state.pharmareceipt !== null ?
                    <BillSuccessPoPUp creditreceipt={this.state.receiptID} phrma_creditreceipt={this.state.pharmareceipt} ClosePopUp={this.ClosesuccessPopUp.bind(this)} /> : null}
            </Box>
        )
    }
}

export default withTranslation()(CreditBills)
